<div class="auth-callback-loading" *ngIf="isLoadingTenantSwitcher">
  <gains-spinner></gains-spinner>
</div>
